export const padTwo = (input) => input.toString().padStart(2, '0');
